import { useCallback } from 'react';

import { CREATE_SPELL_IGNORE_MUTATION } from 'src/graphql/spellCheck/mutation';
import { useMutation } from 'src/graphql';

export const useJobCreateSpellIgnore = () => {
  const [createSpellIgnoreCall, { loading }] = useMutation(CREATE_SPELL_IGNORE_MUTATION);

  const createSpellIgnore = useCallback(async ({ jobId, words }) => {
    return createSpellIgnoreCall({
      variables: {
        jobId,
        words,
      },
    });
  },
  [],
  );

  return {
    createSpellIgnore,
    isLoading: loading,
  };
};
